export default {"src":"/_next/static/media/live.5bdf9166.svg","height":12,"width":32};